<template>
    <div class="row">
        <div class="col-3 form-group"
             v-for="scenarioBatch in sortedScenarioBatches"
             :key="scenarioBatch.scenarioId"
        >
            <scenario-batch-list-item
                    v-bind:scenarioBatch="scenarioBatch"
                    v-bind:can-cancel="aggregatedScenarioValues[scenarioBatch.scenarioId].canCancel"
                    v-bind:is-cancelled="aggregatedScenarioValues[scenarioBatch.scenarioId].isCancelled"
                    v-bind:estimated-costs="aggregatedScenarioValues[scenarioBatch.scenarioId].estimatedCosts"
                    v-bind:estimated-recipients="aggregatedScenarioValues[scenarioBatch.scenarioId].estimatedRecipients"
                    @activate="activate(scenarioBatch.scenarioId)"
                    @deactivate="deactivate(scenarioBatch.scenarioId)"
            >
            </scenario-batch-list-item>
        </div>
    </div>
</template>


<script>
    import sortScenariosMixin from '../../Mixins/sort-scenarios-mixin'

    import dmVisualizerApi from '../../../../Api/dm-visualizer'
    import growler from "../../../../Util/growler";

    import ScenarioBatchListItem from "./ScenarioBatchListItem.vue";

    export default {
        name: "scenario-active-overview",
        mixins: [sortScenariosMixin],
        components: { ScenarioBatchListItem },
        methods: {
            activate(scenarioId){
                const vm = this;
                const batchIds = vm.getScenarioBatchIds(scenarioId);

                dmVisualizerApi.activateBatches(batchIds)
                    .then(
                        scenarioBatches => {
                            vm.emitBatchesUpdated(scenarioId, scenarioBatches);

                            growler.bootstrapInfo(
                                vm.resource('DmVisualizer_ScenarioBatchActivated_SuccessMessage')
                            );
                        },
                        err => growler.bootstrapDanger(err.join('\n'))
                    )
                    .finally(() => vm.hideActivationPopup())
            },
            deactivate(scenarioId){
                const vm = this;
                const batchIds = vm.getScenarioBatchIds(scenarioId);

                dmVisualizerApi.deactivateBatches(batchIds)
                    .then(
                        scenarioBatches => {
                            vm.emitBatchesUpdated(scenarioId, scenarioBatches);

                            growler.bootstrapInfo(
                                vm.resource('DmVisualizer_ScenarioBatchDeactivated_SuccessMessage')
                            );
                        },
                        err => growler.bootstrapDanger(err.join('\n'))
                    )
                    .finally(() => vm.hideDeactivationPopup())
            },
            getScenarioBatchIds(scenarioId){
                return this.aggregatedScenarioValues[scenarioId].batchIds;
            },
            emitBatchesUpdated(scenarioId, batches){
                this.$emit('batches-updated', {
                    scenarioId: scenarioId,
                    batches: batches
                });
            }
        },
        computed: {
            sortedScenarioBatches(){
                //Take the first record per scenario id
                const uniqueScenarios = _.uniqBy(this.scenarioBatches, 'scenarioId');
                
                return this.sortScenarios(uniqueScenarios);
            },
            aggregatedScenarioValues(){
                const scenarioGroupings = _.groupBy(this.scenarioBatches, 'scenarioId');
                
                //Aggregate costs/recipients per scenario id
                return Object.keys(scenarioGroupings).reduce((aggregations, scenarioId) => {
                    aggregations[scenarioId] = {
                        estimatedCosts: _.sumBy(scenarioGroupings[scenarioId], 'estimatedCosts'),
                        estimatedRecipients: _.sumBy(scenarioGroupings[scenarioId], 'estimatedRecipients'),
                        batchIds: scenarioGroupings[scenarioId].map(sg => sg.id),

                        //All or nothing
                        canCancel: scenarioGroupings[scenarioId].reduce((canCancel, sg) => canCancel && sg.canCancel, true),

                        //Only one needs to be cancelled for the scenario to be marked as such
                        isCancelled: scenarioGroupings[scenarioId].reduce((isCancelled, sg) => isCancelled || sg.isCancelled, false)
                    };

                    return aggregations;
                }, {});
            }
        },
        props: {
            scenarioBatches: {
                type: Array,
                required: true
            }
        }
    }
</script>
